export default {
    methods: {
        GoBack() {
            this.$router.go(-1);
        }
    }
}